import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Slider from '@mui/material/Slider';
import { useCallback, useMemo } from 'react';
import { thunkSetSoundVolume } from '../../redux/actions/selfDataActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
/**
 * Sound volumes are saved as negative numbers when muted to preserve what volume level was set at the time of muting.
 */
export const SoundVolumeSlider = () => {
    const dispatch = useAppDispatch();
    const soundVolumePercent = useAppSelector((state) => state.selfData.userClientSettings.SOUND_VOLUME.percent);
    const isSoundOn = soundVolumePercent > 0;
    const onChange = useCallback((event, value) => {
        if (typeof value !== 'number') {
            // number array type is for range sliders, which aren't used by this component
            return;
        }
        dispatch(thunkSetSoundVolume(value));
    }, [dispatch]);
    const style = useMemo(() => (isSoundOn ? {} : { opacity: 0.35 }), [isSoundOn]);
    const absoluteSoundVolumePercent = Math.abs(soundVolumePercent);
    return (_jsx(Slider, { sx: {
            // disabling touch action reduces chance of conflict with other touch event handling (such as on iOS):
            touchAction: 'none'
        }, style: style, "aria-label": 'volume slider', "data-volume-slider-percent": absoluteSoundVolumePercent, min: 0, max: 100, step: 5, value: absoluteSoundVolumePercent, onChange: onChange }));
};
